import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

import { useGetProfileSuspense, useUpdateEventParticipation } from "@/api/bale";
import { DegreeOfSeparationInput } from "@/components/DegreeOfSeparationInput";

import { useCurrentEventSuspense } from "../../../../hooks/useCurrentEvent";

export function DiscoverabilitySection({ className }: { className?: string }) {
  const { t } = useTranslation();
  const me = useGetProfileSuspense("@me", { query: { select: (data) => data.data.profile } });
  const event = useCurrentEventSuspense({ query: { select: (data) => data.data } });
  const updateParticipation = useUpdateEventParticipation();
  const host = event.data.event_participants.find(
    (participant) => participant.profile.id === event.data.event.account_id,
  )!;
  const participantMe = event.data.event_participants.find((participant) => participant.profile.id === me.data.id);

  return (
    <div className={twMerge("flex flex-col gap-4", className)}>
      <p className="font-disinterest">
        {host.profile.id === me.data.id
          ? t("event-default-visibility-tutorial-host")
          : t("event-default-visibility-tutorial")}
      </p>
      <div className="flex flex-row flex-wrap gap-x-4 gap-y-2">
        <div className="flex grow basis-48 flex-col gap-1">
          <p className="ml-4 font-hint">{t("host-default-discoverability")}</p>
          <DegreeOfSeparationInput
            disabled={host.profile.id !== me.data.id}
            defaultValue={host.discoverable_distance}
            onChange={(value) =>
              updateParticipation.mutate({
                accountId: me.data.id,
                eventId: event.data.event.id,
                data: { response: "Attending", discoverable_distance: value },
              })
            }
          />
        </div>
        {participantMe && host.profile.id !== me.data.id && (
          <div className="flex grow basis-48 flex-col gap-1">
            <p className="ml-4 font-hint">{t("your-discoverability")}</p>
            <DegreeOfSeparationInput
              defaultValue={participantMe.discoverable_distance}
              disabled={participantMe.limiting_discoverable_distance === 0}
              onChange={(value) =>
                updateParticipation.mutate({
                  accountId: me.data.id,
                  eventId: event.data.event.id,
                  data: { response: "Attending", discoverable_distance: value },
                })
              }
              max={participantMe.limiting_discoverable_distance}
            />
            <p className="ml-4 font-hint text-placeholder">
              {t("your-sharability-value", { value: participantMe.limiting_discoverable_distance })}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
